/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import React from "react"
import { IComponentProp, isLight } from "@cd2/tools"
import { Icon, IconButton } from "@cd2/components"

export function Pill({
  color = "#f5f5f5",
  large,
  children,
  className,
  icon,
  action,
}: {
  color?: string
  large?: boolean
  children: React.ReactNode
  className?: string
  icon?: IComponentProp<typeof Icon, "icon">
  action?: {
    onClick: () => void
    icon: IComponentProp<typeof Icon, "icon">
  }
}) {
  return (
    <div
      css={css`
        padding: ${large ? "10px 16px" : "5px 8px"};
        border-radius: 3px;
        background: ${color};
        color: ${isLight(color) ? "#333" : "white"};
        font-weight: bold;
        font-size: ${large ? 14 : 12}px;
        display: inline-flex;
        white-space: nowrap;
        gap: 6px;
        align-items: center;
      `}
      className={className}
    >
      {icon && <Icon icon={icon} size={large ? 16 : 14} />}
      {children}
      {action && (
        <div
          css={css`
            margin: -5px -8px;
          `}
        >
          <IconButton
            padding={4}
            iconSize={14}
            icon={action.icon}
            onClick={action.onClick}
            buttonStyle="text"
            color={isLight(color) ? "#333" : "white"}
          />
        </div>
      )}
    </div>
  )
}
